var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const accessibleDocsFormValidation = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailInput = document.querySelector('.js-accessible-docs-email');
    const errorElement = document.querySelector('.js-accessible-docs-popup-error');
    if (!emailInput || !errorElement) {
        console.warn('Email input or error element is not found.');
        return false;
    }
    if (!emailInput || !emailRegex.test(emailInput.value.trim())) {
        errorElement.style.display = 'block';
        return false;
    }
    errorElement.style.display = 'none';
    return true;
};
const sendAccessibleDocsRequest = (email, href) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const formData = new FormData();
        formData.append('action', 'accessible_docs_request');
        formData.append('nonce', accessible_docs_object.nonce);
        formData.append('email', email);
        formData.append('url', href);
        const response = yield fetch(accessible_docs_object.ajax_url, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) {
            accessibleDocsUpdatePopupStatus('error');
            throw new Error(`Response status: ${response.status}`);
        }
        const result = yield response.json();
        if (!result.success) {
            accessibleDocsUpdatePopupStatus('error');
            throw new Error(`Error: ${result.data.error}`);
        }
        if (result.data.status) {
            return result.data.status;
        }
        return 'success';
    }
    catch (error) {
        accessibleDocsUpdatePopupStatus('error');
        throw new Error(`Error: ${error}`);
    }
});
const accessibleDocsUpdatePopupStatus = (status) => {
    const loader = document.querySelector('.js-accessible-docs-popup-loader');
    if (!status) {
        throw new Error('Status parameter is required.');
    }
    const popup = document.querySelector('.js-accessible-docs-popup');
    if (!popup) {
        throw new Error('Accessible docs popup element not found.');
    }
    if (!popup.classList.contains(status)) {
        popup.classList.add(status);
    }
    if (loader) {
        loader.classList.remove('active');
    }
};
const handleSubmitAccessibleDocs = () => __awaiter(void 0, void 0, void 0, function* () {
    const emailInput = document.querySelector('.js-accessible-docs-email');
    const linkElement = document.querySelector('.js-accessible-docs-link');
    const loader = document.querySelector('.js-accessible-docs-popup-loader');
    const isValid = accessibleDocsFormValidation();
    if (isValid && emailInput && linkElement) {
        const email = emailInput.value.trim();
        const href = linkElement.href;
        if (loader) {
            loader.classList.add('active');
        }
        const requestStatus = yield sendAccessibleDocsRequest(email, href);
        if (requestStatus) {
            accessibleDocsUpdatePopupStatus(requestStatus);
        }
        if (loader) {
            loader.classList.remove('active');
        }
    }
});
export default handleSubmitAccessibleDocs;
